/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BreadcrumbItemTypeConstants = {
    Breadcrumb: 'Breadcrumb',
    HierarchyGroup: 'HierarchyGroup'
} as const;
export type BreadcrumbItemTypeConstants = typeof BreadcrumbItemTypeConstants[keyof typeof BreadcrumbItemTypeConstants];


export function BreadcrumbItemTypeConstantsFromJSON(json: any): BreadcrumbItemTypeConstants {
    return BreadcrumbItemTypeConstantsFromJSONTyped(json, false);
}

export function BreadcrumbItemTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreadcrumbItemTypeConstants {
    return json as BreadcrumbItemTypeConstants;
}

export function BreadcrumbItemTypeConstantsToJSON(value?: BreadcrumbItemTypeConstants | null): any {
    return value as any;
}

